import React, { useState, useEffect } from 'react';
import './_style.scss';
import 'react-datepicker/dist/react-datepicker.css';

import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import InputMask from 'react-input-mask';

registerLocale('pt-BR', ptBR);

const CustomInput = ({ ...propsInput }) => (
  <InputMask
    {...propsInput}
    type="text"
    mask="99/99/9999"
  />
);

const updateDate = value => !!value ? moment(value).utc().toDate() : null;

const InputDate = ({
  value,
  onChange,
  placeholder,
  className,
  fields,
  name,
  ...props
}) => {
  const [startDate, setStartDate] = useState(value || null);
  
  useEffect(() => {
    const isSameDate = moment(value).isSame(startDate);
    
    if(!isSameDate) setStartDate(updateDate(value));
  },[value, startDate]);
  

  const onChangeDate = (date) => {
    setStartDate(date);

    if (onChange) {
      const dateFormated = date ? moment(date).utc().format('YYYY-MM-DD') : '';
      onChange(dateFormated);
    }
  }

  return (
    <div className="custom-input-date">
      <DatePicker
        {...props}
        placeholderText={placeholder || "dd/mm/aaaa"}
        locale="pt-BR"
        showPopperArrow={false}
        selected={startDate}
        onChange={onChangeDate}
        isClearable
        dateFormat="dd/MM/yyyy"
        className={`form-control Select-control`}
        date={startDate}
        customInput={<CustomInput />}
      />
    </div>
  );
};

export default InputDate;
